import React from 'react';
import { ICON_SIZE } from '../../utils/constants';
import { ExpandIcon, MinimizeIcon } from '@/assets/icons/v2';
import * as S from '../../styles';

interface FullScreenProps {
	fill?: string;
	fullscreen: boolean;
	onToggleFullscreen?: () => void;
}

export function FullScreen({ fullscreen, onToggleFullscreen, fill }: Readonly<FullScreenProps>): JSX.Element {
	const IconComponent = fullscreen ? MinimizeIcon : ExpandIcon;

	return (
		<S.ControlItem>
			<S.ControlButton
				icon={
					<S.HoverIcon>
						<IconComponent width={ICON_SIZE} height={ICON_SIZE} fill={fill} />
					</S.HoverIcon>
				}
				onClick={onToggleFullscreen}
			/>
		</S.ControlItem>
	);
}
